(function AdzukiToast($, Adzuki)
{
    'use strict';

    const component = {
        props: {
            containerClass: {
                type   : String,
                default: 'toast-container position-fixed d-flex justify-content-center align-items-start top-0 start-50 translate-middle-x'
            },
            containerStyle: {
                type   : String,
                default: 'z-index: 1055; margin-top: 20px;'
            },
            toastClass: {
                type   : String,
                default: 'toast p-1'
            },
            bgClass: {
                type   : String,
                default: 'bg-primary'
            },
            textClass: {
                type   : String,
                default: 'text-white'
            },
            closeButtonClass: {
                type   : String,
                default: 'btn-close-white'
            },
            showIcon: {
                type   : Boolean,
                default: false
            },
            autohide: {
                type   : Boolean,
                default: true
            },
            delay: {
                type   : Number,
                default: 5000
            },
        },

        data() {
            return {
                currentMessage         : '',
                currentIconHtml        : '',
                currentBgClass         : this.bgClass,
                currentTextClass       : this.textClass,
                currentCloseButtonClass: this.closeButtonClass,
                _toastInstance         : null
            };
        },

        computed: {
            toastRootClass() {
                return `${this.toastClass} ${this.currentBgClass}`.trim();
            },
            bodyClass() {
                return `toast-body ${this.currentTextClass}`.trim();
            },
            closeBtnClass() {
                return `btn-close ${this.currentCloseButtonClass} me-2 m-auto`.trim();
            }
        },

        methods: {
            buildDefaultIconHtml(status) {
                if (status === 'success') {
                    return `
                        <span class="fa-stack fa-2x">
                            <i class="fas fa-circle fa-stack-2x text-primary"></i>
                            <i class="fas fa-check fa-stack-1x"></i>
                        </span>
                    `;
                }

                if (status === 'warning') {
                    return `
                        <span class="fa-stack fa-2x">
                            <i class="fas fa-circle fa-stack-2x text-warning"></i>
                            <i class="fas fa-exclamation fa-stack-1x"></i>
                        </span>
                    `;
                }

                if (status === 'info') {
                    return `
                        <span class="fa-stack fa-2x">
                            <i class="fas fa-circle fa-stack-2x text-info"></i>
                            <i class="fas fa-info fa-stack-1x"></i>
                        </span>
                    `;
                }
                return `
                    <span class="fa-stack fa-2x">
                        <i class="fas fa-circle fa-stack-2x text-danger"></i>
                        <i class="fas fa-times fa-stack-1x"></i>
                    </span>
                `;
            },

            /**
             * Call from parent via ref:
             *   this.$refs.toast.openToast('error', 'message')
             *   this.$refs.toast.openToast('error', 'message', { bgClass: 'bg-black', textClass: 'text-white' })
             */
            openToast(status, message, options = {}) {
                const opts = options || {};
                const normalizedStatus = (status === 'success' || status === 'warning' || status === 'info' || status === 'error')
                    ? status
                    : 'error';

                const presets = {
                    success: {
                        bgClass         : this.bgClass,
                        textClass       : this.textClass,
                        closeButtonClass: this.closeButtonClass
                    },
                    error: {
                        bgClass         : 'bg-danger',
                        textClass       : 'text-white',
                        closeButtonClass: 'btn-close-white'
                    },
                    warning: {
                        bgClass         : this.bgClass,
                        textClass       : this.textClass,
                        closeButtonClass: this.closeButtonClass
                    },
                    info: {
                        bgClass         : this.bgClass,
                        textClass       : this.textClass,
                        closeButtonClass: this.closeButtonClass
                    }
                };

                const preset = presets[normalizedStatus] || presets.error;

                this.currentMessage = String(message);

                this.currentBgClass = typeof opts.bgClass === 'string' ? opts.bgClass : preset.bgClass;
                this.currentTextClass = typeof opts.textClass === 'string' ? opts.textClass : preset.textClass;
                this.currentCloseButtonClass = typeof opts.closeButtonClass === 'string'
                    ? opts.closeButtonClass
                    : preset.closeButtonClass;

                if (typeof opts.iconHtml === 'string' && opts.iconHtml.length) {
                    this.currentIconHtml = opts.iconHtml;
                } else {
                    this.currentIconHtml = this.buildDefaultIconHtml(normalizedStatus);
                }

                const toastEl = this.$refs.toastEl;
                if (!toastEl || !window.bootstrap || !window.bootstrap.Toast) {
                    console.warn('Toast not available (missing element or bootstrap.Toast).');
                    return;
                }

                const autohide = typeof opts.autohide === 'boolean' ? opts.autohide : this.autohide;
                const delay    = typeof opts.delay === 'number' ? opts.delay : this.delay;

                this._toastInstance = bootstrap.Toast.getOrCreateInstance(
                    toastEl,
                    {
                        autohide,
                        delay
                    }
                );

                this._toastInstance.show();
            }
        },

        template: `
          <div
              :class="containerClass"
              :style="containerStyle"
              aria-live="polite"
              aria-atomic="true"
          >
            <div ref="toastEl" :class="toastRootClass" role="alert" aria-live="assertive" aria-atomic="true">
              <div class="d-flex align-items-center justify-content-center">
                <div class="toast-icon" v-if="showIcon" v-html="currentIconHtml"></div>
                <div :class="bodyClass" v-text="currentMessage"></div>
                <button
                    type="button"
                    :class="closeBtnClass"
                    data-bs-dismiss="toast"
                    aria-label="Close">
                </button>
              </div>
            </div>
          </div>
        `,
    };

    Adzuki.VueComponents.AdzukiToast = component;
}(jQuery, window.Adzuki || {}));
